/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { fromJS } from 'immutable';

// Initial Sub State
export const initialState = fromJS({
  data: [],
  sorted: [],
  expanded: {},
  selected: '',
  BulkSelected: []
});

// Actions
export const updateInteractionManagementTableData = (arrayOfTableData) => ({
  type: 'SET_INTERACTION_MANAGEMENT_TABLE_DATA',
  arrayOfTableData,
});
export const setExpanded = (expanded) => ({ type: 'SET_EXPANDED', expanded });
export const setSelected = (selected, expanded) => ({
  type: 'SET_SELECTED',
  selected,
  expanded,
});
export const setSorted = (sorted) => ({ type: 'SET_SORTED', sorted });
export const removeSelected = () => ({ type: 'REMOVE_SELECTED' });
export const startInteractionManagement = () => ({
  type: 'START_INTERACTION_MANAGEMENT_BATCH_REQUEST_$',
});
export const startReportingSubscriptions = () => ({
  type: 'START_INTERACTION_MANAGEMENT_REPORTING_SUBSCRIPTION_$',
});
export const reportingSubscriptionStarted = () => ({
  type: 'INTERACTION_MANAGEMENT_REPORTING_SUBSCRIPTION_STARTED_$',
});


export const toggleBulkInteractionChange = (interactionId, isChanged, afterDeletion=null) => ({
  type: 'TOGGLE_BULK_INTERACTION_CHANGE',
  interactionId,
  isChanged,
  afterDeletion
});

export const endInteractions = (interactionId) => ({
  type: 'DELETE_INTERACTION_BY_ID',
  interactionId,
});

export const getBulkCheckboxSet = (bulkSelected, interactionId) => {
    return bulkSelected.indexOf(interactionId) !== -1;
}
// Reducer
export default function InteractionManagement(state = initialState, action) {
  switch (action.type) {
    case 'SET_INTERACTION_MANAGEMENT_TABLE_DATA': {
      let arrayData = [];
      if (action.arrayOfTableData.interactionsInConversationList) {
        const interactionsInConversationList = action.arrayOfTableData.interactionsInConversationList.body.results.interactions;
        if (interactionsInConversationList.length > 0) {
          interactionsInConversationList.forEach(item => {
            item.bulkChangeItem = getBulkCheckboxSet(state.get('BulkSelected'), item.interactionId)
            arrayData.push(item);
          });
        }
      }
      if (action.arrayOfTableData.interactionsInQueueList) {
        const interactionsInQueueList = action.arrayOfTableData.interactionsInQueueList.body.results.interactions;
        if (interactionsInQueueList.length > 0) {
          interactionsInQueueList.forEach(item => {
            item.bulkChangeItem = getBulkCheckboxSet(state.get('BulkSelected'), item.interactionId)
            arrayData.push(item);
          });
        }
      }
      if (action.arrayOfTableData.interactionsInRoutingList) {
        const interactionsInRoutingList = action.arrayOfTableData.interactionsInRoutingList.body.results.interactions;
        if (interactionsInRoutingList.length > 0) {
          interactionsInRoutingList.forEach(item => {
            item.bulkChangeItem = getBulkCheckboxSet(state.get('BulkSelected'), item.interactionId)
            arrayData.push(item);
          });
        }
      }
      return state.set('data', fromJS(arrayData));
    }
    case 'TOGGLE_BULK_INTERACTION_CHANGE': {
      const { interactionId, isChanged, afterDeletion} = action;
      //to remove the interaction id after successful end operation/not exists...
      if (afterDeletion !== null) {
       //clear the BulkSelected list after a bulk end operation..
        return state
          .set('BulkSelected', fromJS([]));
      }

      const interactionIndex = state.get('data').findIndex(row => row.get('interactionId') === interactionId);
      let bulkSelected = [];
      if (interactionIndex !== -1 && isChanged !== undefined && isChanged === true) {
        bulkSelected = state.get('BulkSelected').toJS();
        if (bulkSelected.indexOf(interactionId) === -1) {
          bulkSelected.push(interactionId);
        }
        return state
          .setIn(['data', interactionIndex, 'bulkChangeItem'], isChanged)
          .set('BulkSelected', fromJS(bulkSelected));
      } else if (interactionIndex !== -1) {
         // We remove interactionid from BulkSelection array when "Unselect" is pressed..
         bulkSelected = state.get('BulkSelected').toJS();
         bulkSelected = bulkSelected.filter(interactionID => interactionID !== interactionId);
         return state
           .setIn(['data', interactionIndex, 'bulkChangeItem'], false)
           .set('BulkSelected', fromJS(bulkSelected));
      } else {
        bulkSelected = state.get('BulkSelected').toJS();
        bulkSelected = bulkSelected.filter(interactionID => interactionID !== interactionId);
        return state
          .set('BulkSelected', fromJS(bulkSelected));
      }
    }
    case 'SET_SORTED':
      return state
        .set('sorted', action.sorted)
        .set('selected', '')
        .set('expanded', {});
    case 'SET_EXPANDED':
      return state.set('expanded', action.expanded);
    case 'SET_SELECTED':
      return state.set('selected', action.selected).set('expanded', action.expanded);
    case 'REMOVE_SELECTED':
      return state.set('expanded', {}).set('selected', '');
    default:
      return state;
  }
}
